import React, {useEffect, useState} from 'react';
import {Responsive as ResponsiveGridLayout} from "react-grid-layout";
import styled from 'styled-components';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import DragBg from '../../../assets/drag-bg.svg';

//const ReactGridLayout = WidthProvider(ResponsiveGridLayout);

const DragField = styled(ResponsiveGridLayout)`

  ${props => props.isDragging ? `
    background: url(${DragBg});
    background-repeat: repeat-y;
    background-position:-3px 0px;
    background-size: 100% 51px;
  `: ''}`;

const cols = {lg:4,sm:2,xs:1};
const breakpoints = {lg: 1280, sm: 768, xs: 480};

const DashboardDragField = ({ children, width, dashboardItems, panelId, onUpdateCardConfig}) => {
    const [isDragging, setIsDragging] = useState(false);

    const handleDragEnd = (layout) => {
      setIsDragging(false);
      const cardConfig = layout.map(item => {
        const id = parseInt(item.i.replace("dashitem-", ""), 10);
        const { x, y, w, h } = item;
        return {
          id,
          cardConfig: JSON.stringify({ x, y, w, h })
        };
      });
      onUpdateCardConfig(cardConfig, panelId);
    };

    return (
        <DragField
            className="layout"
            rowHeight={120}
            width={width}
            cols={cols}
            margin={[12,12]}
            compactType='vertical'
            breakpoints={breakpoints}
            resizeHandles={['se']}
            style={{position:'relative'}}
            onDragStart={() => setIsDragging(true)}
            onDragStop={handleDragEnd}
            draggableHandle='.drag'
            onResizeStart={() => setIsDragging(true)}
            onResizeStop={handleDragEnd}
            isDragging={isDragging} 
            isBounded={true}
        >
            {children}
        </DragField>
    );
}

export default DashboardDragField;